module.exports = __webpack_public_path__ + "img/pobednikR.e15d5f19.png";